import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useLocation } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { useGates } from '../../hooks/useGates';
import { jsx as _jsx } from "react/jsx-runtime";
export function ClearFiltersButton() {
  const params = useSearchParams();
  const gates = useGates();
  const location = useLocation();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const handleClick = () => {
    const keysToKeep = ['search', 'queryType', 'sort'];

    // if there are search tabs, don't clear the product type filter,
    // because that would move the user back to the "All" tab
    if (gates.solutionsSpringSpotlight && location.pathname === Paths.SEARCH_RESULTS) {
      keysToKeep.push('PRODUCT_TYPE');
    }
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'clear all filters'
    }));
    params.keys().forEach(key => {
      if (!keysToKeep.includes(key)) params.delete(key);
    });
  };
  return (
    /*#__PURE__*/
    // wrapping in a div to prevent unwanted expansion
    _jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.clearAll"
        })
      })
    })
  );
}